document.addEventListener('DOMContentLoaded', function() {
  const dropdown = document.getElementById('eventsFilter');
  if (!dropdown) return;

  const btn = dropdown.querySelector('.events-filter-btn');
  const menu = dropdown.querySelector('.events-filter-menu');
  const selectedTextSpan = dropdown.querySelector('.filter-selected-text');
  const options = dropdown.querySelectorAll('.filter-option');
  
  // Toggle Dropdown
  btn.addEventListener('click', (e) => {
    e.stopPropagation();
    const expanded = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', !expanded);
  });

  // Close when clicking outside
  document.addEventListener('click', (e) => {
    if (!dropdown.contains(e.target)) {
      btn.setAttribute('aria-expanded', 'false');
    }
  });

  // Filter Logic
  options.forEach(option => {
    option.addEventListener('click', () => {
      const value = option.dataset.value;
      // Get text node after the checkmark span
      const text = option.lastChild.textContent.trim(); 

      // Update UI
      selectedTextSpan.textContent = text;
      
      options.forEach(opt => {
        opt.classList.remove('selected');
        opt.querySelector('.checkmark').textContent = '';
      });
      option.classList.add('selected');
      option.querySelector('.checkmark').textContent = '✓';

      btn.setAttribute('aria-expanded', 'false');

      // Filter Grid Items
      const gridItems = document.querySelectorAll('.events-grid__item');
      let visibleCount = 0;
      
      gridItems.forEach(item => {
        const status = item.dataset.status;
        if (value === 'all' || status === value) {
            item.style.display = '';
            visibleCount++;
        } else {
            item.style.display = 'none';
        }
      });

      // Toggle No Events Message
      const noEventsMsg = document.querySelector('.no-events-message');
      if (noEventsMsg) {
          noEventsMsg.style.display = visibleCount === 0 ? 'block' : 'none';
      }
    });
  });
});
